<template>
  <L1 class="TicketInformation">
    <div class="content">
      <div class="tickets">
        <div class="prices">
          <div class="titleName">入園票價
            <EditBtn :style="{marginLeft: 'auto'}" @click="edit=!edit"></EditBtn>
          </div>
          <div class="pricesContent">
            <table>
              <thead>
                <tr>
                  <th>品項</th>
                  <th>貨編</th>
                  <th>售價</th>
                </tr>
              </thead>
              <tbody v-if="!edit">
                <tr v-for="(ticket, i) in tickets" :key="`ticket-${i}`">
                  <td>{{ticket.name}}</td>
                  <td>{{ticket.id}}</td>
                  <td class="red">$ {{ticket.price}}</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr v-for="(ticket, i) in tickets" :key="`ticket-${i}`">
                  <td><input type="text" v-model="ticket.name"></td>
                  <td><input type="text" v-model="ticket.id"></td>
                  <td><input type="text" v-model="ticket.price"></td>
                </tr>
              </tbody>
            </table>
            <div class="btns" v-if="edit"><button class="cancel" @click="edit=false">取消</button>
            <button class="confirm" @click="save">確認</button></div>
          </div>
        </div>
      </div>
      <div>

      <div class="parcentage" v-if="distribute"  :style="{width: '595px'}">
        <div class="titleName">平/假日分潤
          <EditBtn @click="fnEditDistribute"></EditBtn>
        </div>
        <div class="parcentageContent"  :style="{width: '495px'}">
          <table :style="{width: '495px'}">
            <thead>
              <tr>
                <th rowspan="2"></th>
                <th colspan="2">參訪日</th>
                <th colspan="2">二訪</th>
              </tr>
              <tr>
                <th>門票</th>
                <th>二消</th>
                <th>門票</th>
                <th>二消</th>
              </tr>
            </thead>
            <tbody v-if="!editDistribute&&distribute.length>0">
              <tr>
                <td>平日</td>
                <td class="red">{{distribute.find(e => e.type==='general').parcentage * 100}} %</td>
                <td class="red">{{distribute.find(e => e.type==='general_consume').parcentage * 100}} %</td>
                <td class="red">{{distribute.find(e => e.type==='general_2nd').parcentage * 100}} %</td>
                <td class="red">{{distribute.find(e => e.type==='general_2nd_consume').parcentage * 100}} %</td>
              </tr>
              <tr>
                <td>假日</td>
                <td class="red">{{distribute.find(e => e.type==='holiday').parcentage * 100}} %</td>
                <td class="red">{{distribute.find(e => e.type==='holiday_consume').parcentage * 100}} %</td>
                <td class="red">{{distribute.find(e => e.type==='holiday_2nd').parcentage * 100}} %</td>
                <td class="red">{{distribute.find(e => e.type==='holiday_2nd_consume').parcentage * 100}} %</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td>平日</td>
                <td class="red"><input type="text" v-model.number="parcentageGeneral"></td>
                <td class="red"><input type="text" v-model.number="parcentageGeneral_consume"></td>
                <td class="red"><input type="text" v-model.number="parcentageGeneral_2nd"></td>
                <td class="red"><input type="text" v-model.number="parcentageGeneral_2nd_consume"></td>
              </tr>
              <tr>
                <td>假日</td>
                <td class="red"><input type="text" v-model.number="parcentageHoliday"></td>
                <td class="red"><input type="text" v-model.number="parcentageHoliday_consume"></td>
                <td class="red"><input type="text" v-model.number="parcentageHoliday_2nd"></td>
                <td class="red"><input type="text" v-model.number="parcentageHoliday_2nd_consume"></td>
              </tr>
            </tbody>
          </table>
          <div v-if="editDistribute" class="btns"><button class="cancel" @click="editDistribute=false">取消</button>
          <button class="confirm" @click="updateDistribute">確認</button></div>
        </div>
      </div>
      <editCube :style="{marginTop: '40px'}" :width="645" title="團體屬性" :keyname="'teamAttributes'"/>
      <editCube :width="645" title="代理商類別" :keyname="'agencyCategories'"/>
      </div>
    </div>
  </L1>
</template>

<script>
import L1 from '../../components/layout/L1.vue'
import EditBtn from '../../components/btn/edit.vue'
import editCube from '../../components/editCube14.vue'
import { getapi, postapi } from '../../store/fetch'
export default {
  name: 'TicketInformation',
  components: {
    L1,
    EditBtn,
    editCube
  },
  data () {
    return {
      distribute: [],
      tickets: [],
      holidays: [],
      holidays2: [],
      addholiday: false,
      removeholiday: false,
      edit: false,
      editDistribute: false,
      parcentageGeneral: 0,
      parcentageHoliday: 0,
      parcentageGeneral_consume: 0,
      parcentageGeneral_2nd: 0,
      parcentageHoliday_consume: 0,
      parcentageHoliday_2nd: 0,
      parcentageGeneral_2nd_consume: 0,
      parcentageHoliday_2nd_consume: 0
    }
  },
  async created () {
    this.getHolidays()
    this.getTickets()
    this.getDistribute()
  },
  methods: {
    async save () {
      // console.log(this.tickets)
      const r = await postapi('products/tickets', { tickets: this.tickets })
      if (r) {
        this.tickets = r
        this.edit = false
      }
    },
    async updateDistribute () {
      const r = await postapi('selections/distribute', {
        data:
          [
            {
              type: 'holiday',
              parcentage: this.parcentageHoliday
            },
            {
              type: 'general',
              parcentage: this.parcentageGeneral
            },
            {
              type: 'general_consume',
              parcentage: this.parcentageGeneral_consume
            },
            {
              type: 'holiday_consume',
              parcentage: this.parcentageHoliday_consume
            },
            {
              type: 'general_2nd',
              parcentage: this.parcentageGeneral_2nd
            },
            {
              type: 'holiday_2nd',
              parcentage: this.parcentageHoliday_2nd
            },
            {
              type: 'general_2nd_consume',
              parcentage: this.parcentageGeneral_2nd_consume
            },
            {
              type: 'holiday_2nd_consume',
              parcentage: this.parcentageHoliday_2nd_consume
            }
          ]
      })
      if (r) {
        this.distribute = r
        this.editDistribute = false
      }
    },
    fnEditDistribute () {
      this.parcentageHoliday = this.distribute.find(e => e.type === 'holiday').parcentage
      this.parcentageGeneral = this.distribute.find(e => e.type === 'general').parcentage
      this.parcentageGeneral_consume = this.distribute.find(e => e.type === 'general_consume').parcentage
      this.parcentageHoliday_consume = this.distribute.find(e => e.type === 'holiday_consume').parcentage
      this.parcentageGeneral_2nd = this.distribute.find(e => e.type === 'general_2nd').parcentage
      this.parcentageHoliday_2nd = this.distribute.find(e => e.type === 'holiday_2nd').parcentage
      this.parcentageGeneral_2nd_consume = this.distribute.find(e => e.type === 'general_2nd_consume').parcentage
      this.parcentageHoliday_2nd_consume = this.distribute.find(e => e.type === 'holiday_2nd_consume').parcentage
      this.editDistribute = true
    },
    async getDistribute () {
      this.distribute = await getapi('selections/distribute')
    },
    async getTickets () {
      this.tickets = await getapi('products/tickets')
    },
    updateHoliday (id) {
      this.getHolidays()
    },
    async getHolidays () {
      const holidays = await getapi('holidays')
      this.holidays = holidays.map(e => {
        return this.moment(e.date).format('M/D') + `(${['日', '一', '二', '三', '四', '五', '六'][this.moment(e.date).day()]})`
      })
      this.holidays2 = holidays.map(e => {
        return this.moment(e.date).format('M/D')
      }).join('、')
    }
  }

}
</script>
<style lang="scss">
.TicketInformation{
  .dialogBg {
    left: 663px;
    right: 0;
    width: 1185px!important;
  }
}
</style>
<style lang="scss" scoped>
.scrollbar {
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 7px;
    background-color: #F5F5F5;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 20px;
    box-shadow: inset 0 0 6px #0000004d;
    background-color: var(--color-pri);
  }
  &::-webkit-scrollbar-track {
    border: none;
    border-radius: 20px;
    background-color: #d8d8d8;
    border: 2px solid #FFFFFF!important;
  }
}
.tickets {
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 7px;
    background-color: #F5F5F5;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 20px;
    box-shadow: inset 0 0 6px #0000004d;
    background-color: var(--color-pri);
  }
  &::-webkit-scrollbar-track {
    border: none;
    border-radius: 20px;
    background-color: #d8d8d8;
    border: 2px solid #FFFFFF!important;
  }
}
.btns {
  display: flex!important;
  align-items: center;
  justify-content: flex-end;
  gap: 28px;
  margin-top: 17px!important;
  margin-bottom: 25px!important;
  button {
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 23px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100px;
    height: 35px;
    border-radius: 20px;
    border: none;
  }
  .cancel {
    background-color: var(--color-cancel);
  }
  .confirm {
    background-color: var(--color-confirm);
  }
}
.parcentageContent {
  table {
    border-collapse: collapse;
  }
  input {
    text-align: center;
    padding-inline: 5px;
    box-sizing: border-box;
    height: 65px;
  }
  thead>tr:nth-child(2) {
    th {
      background-color: var(--color-infobox);
      color: var(--color-checked);
      font-weight: 700;
    }
  }
}
.pricesContent {
  th, td {
    box-sizing: border-box;
    &:nth-child(1) {
      text-align: start;
    }
    &:nth-child(1) { width: 351px; }
    &:nth-child(2) { width: 161px; }
    &:nth-child(3) { width: 125px; }
    &:nth-child(1) > input { text-align: start; }
    &:nth-child(2) > input { text-align: center; }
    &:nth-child(3) > input { text-align: center; color: var(--color-confirm);}
  }
}
.pricesContent, .parcentageContent {
  margin-top: 23px;
  table {
    border: 1px solid #C4C4C4;
    tr:not(:last-child) {
      border-bottom: 1px solid #C4C4C4;
    }
    th:not(:last-child), td:not(:last-child) {
      border-right: 1px solid #C4C4C4;
    }
    th {
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 20px;
      text-align: center;
      letter-spacing: 0.1em;
      color: #FFFFFF;
    }
    td {
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 20px;
      letter-spacing: 0.1em;
      color: var(--color-letter);
      line-height: 1.5em;
      padding-block: 8px;
    }
    th ,td {
      input {
        box-sizing: border-box;
        width: calc(100% - 10px);
        height: 100%;
        border: none;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 20px;
        letter-spacing: 0.1em;
        color: var(--color-letter);
      }
      &:nth-child(1) {
        padding-inline: 12px;
      }
    }
    td.red {
      font-family: Roboto;
      font-style: normal;
      font-weight: 900;
      font-size: 20px;
      text-align: center;
      letter-spacing: 0.1em;
      color: var(--color-confirm);
    }
    thead {
      tr {
        border-top: 1px solid #C4C4C4;
        height: 40px;
      }
      tbody tr{
        min-height: 64px;
      }
      width: 100%;
      background-color: var(--color-checked);
      color: #FFFFFF;
    }
    tbody {
      overflow-y: hidden;
    }
  }
}
.parcentage {
  width: 536px;
}
.tickets {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.holidayContent {
  text-align: start;
  display: flex;
  flex-direction: column;
  gap: 25px;
  margin-block: 30px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  letter-spacing: 0.1em;
  color: var(--color-letter);
  table {
    width: 966px;
  }
  thead {text-align: start;}
  tbody {
    overflow-y: hidden;
  }
  tr:not(:last-child) {
    border-bottom: 1px solid #C4C4C4;
  }
  th:not(:last-child), td:not(:last-child) {
    border-right: 1px solid #C4C4C4;
  }
  td {
    text-align: center;
  }
  table {
    border: 1px solid #C4C4C4;
    tr:hover {
      background-color: transparent;
    }
  }
  thead {
    background-color: var(--color-checked);
    color: #FFFFFF;
    width: 100%;
    th {
      height: 57px;
      padding-inline: 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      button {
        background-color: transparent;
        border: none;
      }

    }
  }
}
.titleName {
  text-align: start;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 25px;
  letter-spacing: 0.1em;
  color: var(--color-checked);
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.TicketInformation {

  padding-inline: 18px 9px!important;
  .content {
    display: grid;
    grid-template-columns: 745px 1fr;
    grid-template-rows: calc(100vh - 89px);
    &>:nth-child(1) {
      border-right: 1px solid var(--color-border);
    }
    &>div {
      width: 100%;
      height: 100%;
      padding-block: 28px;
      padding-inline: 50px;
      box-sizing: border-box;
    }
  }
 }
.header {
  height: 89px;
  display: flex;
  align-items: center;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 36px;
  letter-spacing: 0.15em;
  border-bottom: 1px solid var(--color-border);
  color: var(--color-pri);
  gap: 20px;
  span {
    display: inline-flex;
    align-items: center;
    gap: 10px;
  }
}
.box {
  width: 422px;
  height: 505px;
  min-height: 505px;
  border: 1px solid var(--color-pri);
  border-radius: 10px;
  box-sizing: border-box;
}
</style>
